import useAuthors from './authorsAtom';

export * from './authorsAtom';

export default useAuthors;
